"use client";

import { useConsentManager } from "@c15t/nextjs";
import { useEffect, useState } from "react";

export function useHasTelemetryConsent() {
  const consentManager = useConsentManager();
  const [hasMounted, setHasMounted] = useState(false);

  useEffect(() => {
    setHasMounted(true);
  }, []);

  return hasMounted && consentManager.has("measurement");
}
